// Bloqueo del TPV por inactividad («Tiempo para solicitar identificación de
// empleado») — decisión pura, sin dependencias (testeable sin axios/store).
//
// 2026-10-18 · Con el ajuste desactivado el kiosko se abría igual tras un
// rato sin tocar la tablet. Los guards de los layouts solo paraban con el
// valor LITERAL 0 (`timeToRequestEmployee === 0`): cualquier otro valor
// «apagado» (null de un restaurante antiguo, undefined mientras el user no
// ha cargado, "0" en texto) seguía con el temporizador — y además con
// valores por defecto (TpvCartaLayout `|| 60` s; useInactivity fuerza 120 s
// fuera del TPV). Ahora el bloqueo solo existe si el control de empleados
// está activo Y hay un tiempo > 0 válido; en cualquier otro caso, nunca.

/** Segundos de inactividad tras los que se bloquea, o null si está desactivado. */
export function inactivityLockSeconds(user) {
  if (!user) return null;
  const enabled = user.requestUserIdentity === true || user.requestUserIdentity === "true";
  if (!enabled) return null;
  const raw = user.timeToRequestEmployee;
  if (raw === null || raw === undefined || raw === "") return null;
  const seconds = Number(raw);
  return Number.isFinite(seconds) && seconds > 0 ? seconds : null;
}

/** ¿Hay que abrir el kiosko por inactividad ahora mismo? */
export function shouldLockOnInactivity({
  user,
  isInactive,
  kioskOpen,
  currentActiveEmployee,
  isEmployeeWebSession = false,
}) {
  // Sesión personal del empleado (login web / QR personal): cambiar de
  // usuario no está permitido en ese flujo.
  if (isEmployeeWebSession) return false;
  if (!isInactive || kioskOpen) return false;
  // Sin empleado identificado (admin = 0, o nadie) no hay nada que bloquear.
  if (!currentActiveEmployee) return false;
  return inactivityLockSeconds(user) !== null;
}
